import * as React from 'react';
import SelectSearchComponent from '../../../../../common/components/SelectSearchComponent';
import {
    GLOBAL,
    LOAN_APPLICATION_MX
} from '../../../../constants/LabelConstants';
import {formatCurrency} from '../../../../utils/CurrencyUtils';
import {COUNTRY_INITIALS} from '../../../../../common/constants/AppConstants';
import {INPUTS} from '../../../../constants/MX/WizardInputs';
import * as InputTextTypes from '../../../../../common/components/InputTextTypes';
import InputText from '../../../../../common/components/InputText';
import DatePicker from '../../../../../common/components/DatePicker';
import {WorkDataSectionProps} from '../../../../types/mx/turboCash/components';

class WorkDataSectionView extends React.Component<WorkDataSectionProps, {}> {

    constructor(props) {
        super(props);
    }

    render() {
        const {
            workplaceNameField,
            positionField,
            workingSinceField,
            employmentRotation,
            employmentRotationField,
            addressField,
            extNumberField,
            intNumberField,
            streetBetweenField,
            workplacePhoneField,
            workplacePhoneExtField,
            monthlyIncomesField,
            postalCodeField,
            stateField,
            cityField,
            municipalityField,
            colonies,
            colonyField,
            showErrors
        } = this.props;
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <InputText label={LOAN_APPLICATION_MX.EMPLOYMENT_COMPANY_NAME}
                                   id={INPUTS.EMPLOYMENT_COMPANY_NAME}
                                   value={workplaceNameField.value}
                                   required
                                   hasError={showErrors}
                                   labelError={workplaceNameField.error}
                                   onChange={this.props.onChangeWorkplaceName}/>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <InputText label={LOAN_APPLICATION_MX.EMPLOYMENT_POSITION}
                                   id={INPUTS.EMPLOYMENT_POSITION}
                                   value={positionField.value}
                                   required
                                   hasError={showErrors}
                                   labelError={positionField.error}
                                   onChange={this.props.onChangePosition}/>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <DatePicker label={LOAN_APPLICATION_MX.EMPLOYMENT_START_DATE}
                                    id={INPUTS.EMPLOYMENT_START_DATE}
                                    value={workingSinceField.value}
                                    required
                                    hasError={showErrors}
                                    labelError={workingSinceField.error}
                                    onChange={this.props.onChangeWorkingSince}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <SelectSearchComponent
                            label={LOAN_APPLICATION_MX.EMPLOYMENT_TURN}
                            id={INPUTS.EMPLOYMENT_TURN}
                            placeholder={GLOBAL.SELECT}
                            value={employmentRotationField.value}
                            data={employmentRotation}
                            required
                            onChange={this.props.onChangeEmploymentRotation}
                            labelError={employmentRotationField.error}
                            hasError={showErrors}/>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <InputText label={LOAN_APPLICATION_MX.EMPLOYMENT_ADDRESS}
                                   id={INPUTS.EMPLOYMENT_ADDRESS}
                                   value={addressField.value}
                                   required
                                   hasError={showErrors}
                                   labelError={addressField.error}
                                   onChange={this.props.onChangeAddress}/>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <InputText label={LOAN_APPLICATION_MX.EMPLOYMENT_EXTERNAL_NUMBER}
                                   id={INPUTS.EMPLOYMENT_EXTERNAL_NUMBER}
                                   value={extNumberField.value}
                                   required
                                   maxLength={20}
                                   hasError={showErrors}
                                   labelError={extNumberField.error}
                                   onChange={this.props.onChangeExtNumber}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <InputText label={LOAN_APPLICATION_MX.EMPLOYMENT_INTERNAL_NUMBER}
                                   id={INPUTS.EMPLOYMENT_INTERNAL_NUMBER}
                                   value={intNumberField.value}
                                   maxLength={20}
                                   hasError={showErrors}
                                   labelError={intNumberField.error}
                                   onChange={this.props.onChangeIntNumber}/>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <InputText label={LOAN_APPLICATION_MX.EMPLOYMENT_STREET_BETWEEN}
                                   id={INPUTS.EMPLOYMENT_STREET_BETWEEN}
                                   value={streetBetweenField.value}
                                   required
                                   hasError={showErrors}
                                   labelError={streetBetweenField.error}
                                   onChange={this.props.onChangeStreetBetween}/>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <InputText label={LOAN_APPLICATION_MX.EMPLOYMENT_POSTAL_CODE}
                                   id={INPUTS.EMPLOYMENT_POSTAL_CODE}
                                   value={postalCodeField.value}
                                   maxLength={5}
                                   minLength={5}
                                   required
                                   hasError={showErrors}
                                   labelError={postalCodeField.error}
                                   type={InputTextTypes.NUMBER}
                                   onChange={this.props.onChangePostalCode}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <InputText
                            label={LOAN_APPLICATION_MX.EMPLOYMENT_STATE}
                            id={INPUTS.EMPLOYMENT_STATE}
                            required
                            hasError={showErrors}
                            labelError={stateField.error}
                            value={stateField.value}/>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <InputText
                            label={LOAN_APPLICATION_MX.EMPLOYMENT_CITY}
                            id={INPUTS.EMPLOYMENT_CITY}
                            hasError={showErrors}
                            labelError={cityField.error}
                            value={cityField.value}/>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <InputText
                            label={LOAN_APPLICATION_MX.EMPLOYMENT_MUNICIPALITY}
                            id={INPUTS.EMPLOYMENT_MUNICIPALITY}
                            required
                            hasError={showErrors}
                            labelError={municipalityField.error}
                            value={municipalityField.value}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <SelectSearchComponent
                            id={INPUTS.EMPLOYMENT_COLONY}
                            label={LOAN_APPLICATION_MX.EMPLOYMENT_COLONY}
                            placeholder={GLOBAL.SELECT}
                            value={colonyField.value}
                            data={colonies}
                            required
                            onChange={this.props.onChangeColony}
                            labelError={colonyField.error}
                            hasError={showErrors}/>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <InputText label={LOAN_APPLICATION_MX.EMPLOYMENT_PHONE}
                                   id={INPUTS.EMPLOYMENT_PHONE}
                                   value={workplacePhoneField.value}
                                   maxLength={10}
                                   minLength={10}
                                   required
                                   hasError={showErrors}
                                   labelError={workplacePhoneField.error}
                                   type={InputTextTypes.NUMBER}
                                   onChange={this.props.onChangeWorkplacePhone}/>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <InputText label={LOAN_APPLICATION_MX.EMPLOYMENT_PHONE_EXT}
                                   id={INPUTS.EMPLOYMENT_PHONE_EXT}
                                   value={workplacePhoneExtField.value}
                                   maxLength={20}
                                   hasError={showErrors}
                                   labelError={workplacePhoneExtField.error}
                                   type={InputTextTypes.NUMBER}
                                   onChange={this.props.onChangeWorkplacePhoneExt}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <InputText label={LOAN_APPLICATION_MX.EMPLOYMENT_MONTHLY_INCOME}
                                   id={INPUTS.EMPLOYMENT_MONTHLY_INCOME}
                                   value={formatCurrency(
                                       monthlyIncomesField.value,
                                       COUNTRY_INITIALS.MEXICO, '$', 0
                                   )}
                                   type={InputTextTypes.NUMBER}
                                   maxLength={12}
                                   minValue={1}
                                   required
                                   hasError={showErrors}
                                   labelError={monthlyIncomesField.error}
                                   onChange={this.props.onChangeMonthlyIncomes}/>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default WorkDataSectionView;